<template>
  <div class="header-lang">
    <div class="header-lang-body" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <i class="icon iconfont icon-lang"></i>
    </div>
    <div class="header-lang-dropdown dropdown-menu">
      <div class="drop-item" @click="changeLang('en')">{{$t("header.langList.en")}}</div>
      <div class="drop-item" @click="changeLang('zh')">{{$t("header.langList.zh")}}</div>
      <!-- <div class="drop-item" @click="changeLang('kr')">{{$t("header.langList.kr")}}</div> -->
    </div>
  </div>
</template>

<script>
import nknStorage from "@/assets/js/nknStorage";
import { mapMutations } from "vuex";
export default {
  inject: ["reload"],
  methods: {
    ...mapMutations(["setLang"]),
    changeLang: function(lang) {
      let path = this.$route.name;
      if (path === "home") {
        this.$router.push("/" + lang + "/");
      } else {
        this.$router.push("/" + lang + "/" + path + "/");
      }

      if (this.$route.name === "news") {
        location.reload();
      } else {
        this.setLang(lang);
        this.$i18n.locale = lang;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.lang-text {
  display: none;
}

@media screen and (max-width: 768px) {
  .lang-text {
    display: inline-block;
  }
  .icon-lang {
    font-size: 22px;
  }
}
.header-lang {
  display: flex;
  align-items: center;
  position: relative;

  &-body {
    margin: 0 1.5rem 0 2rem;
    cursor: pointer;
    @include nkn-font-set(16px, #24397d);

    &:hover {
      color: #1791f2;
    }
  }

  &-dropdown {
    margin-right: 0;
    width: 120px;
    min-width: auto;
    padding: 0 10px;
    margin-left: 0;
    @media screen and (min-width: 768px) {
      /*margin-left: 34px;*/
    }
    .drop-item {
      display: block;
      text-align: center;
      line-height: 20px;
      font-size: 12px;
      padding: 4px 0;
      margin: 0 auto;
      cursor: pointer;
      @media (max-width: 992px) {
        font-size: 14px;
      }
    }
    /*div+div {*/
    /*border-top: 1px solid #ccc;*/
    /*}*/
  }

  // &-dropdown {
  //   position: absolute; top: 80px;left: 40px;z-index: 2;
  //   display: none;
  //   min-width: 4.5rem;box-sizing: border-box;
  //   padding: 0 .5rem;border-radius: .2rem;
  //   background: #fff;
  //   .drop-item{
  //     @include nkn-font-set(.6rem, #0c173b);
  //     line-height: 1.6rem;
  //     cursor: pointer;
  //     &:hover{
  //       color: #1791f2;
  //     }
  //   }

  //   &>div+div{
  //     border-top: 1px solid #c4c7d0;
  //   }
  // }

  // &:hover &-dropdown {
  //   display: block;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/header/nknHeaderLang.vue